//@ts-nocheck
// CWA2Sigma.ts
import { observeTradingViewMenuAndToggleDashboard } from './helpers';
function CWA2SigmaIndicator(PineJS) {
    return {
        name: "CWA 2 Sigma",
        metainfo: {
            _metainfoVersion: 52,
            id: "CWA2Sigma@tv-basicstudies-1",
            name: "CWA 2 Sigma",
            description: "CWA 2 Sigma Indicator",
            shortDescription: "CWA2σ",
            is_price_study: true,
            is_hidden_study: false,
            isTVScript: false,
            isTVScriptStub: false,
            defaults: {
                styles: {
                    BBTop: { plottype: "line", visible: true, color: "#F57F17", width: 1 },
                    ATRSL: { plottype: "line", visible: true, color: "#006064", width: 1 },
                    EMA: { plottype: "line", visible: true, color: "#FF5252", width: 1 },
                    BuyPrice: { plottype: "line", visible: true, color: "#2962FF", width: 1 },
                    BuySL: { plottype: "line", visible: false, color: "#FF9800", width: 1 },
                    BuyMarker: {
                        plottype: "shape_label_up",
                        visible: true,
                        location: "BelowBar",
                        transparency: 0,
                        color: "green",
                        text: "Buy",
                        size: "small",
                        textColor: "white"
                    },
                    SellMarker: {
                        plottype: "shape_label_down",
                        visible: true,
                        location: "AboveBar",
                        transparency: 0,
                        color: "red",
                        text: "Sell",
                        size: "small",
                        textColor: "white"
                    },
                },
                inputs: {
                    bbPeriod: 50,
                    bbWidth: 2.0,
                    emaPeriod: 100,
                    atrPeriod: 14,
                    atrFactor: 1.8,
                    slMode: "%",
                    slValue: 20,
                    showDashboard: true
                }
            },
            plots: [
                { id: "BBTop", type: "line", plottype: 9 },
                { id: "ATRSL", type: "line", plottype: 9 },
                { id: "EMA", type: "line", plottype: 9 },
                { id: "BuyPrice", type: "line" },
                { id: "BuySL", type: "line" },
                { id: "BuyMarker", type: "shapes" },
                { id: "SellMarker", type: "shapes" },
            ],
            styles: {
                BBTop: { title: "BBTop", isHidden: false, plottype: "line", visible: true, color: "#F57F17", width: 1 },
                ATRSL: { title: "ATRSL", isHidden: false, plottype: "line", visible: true, color: "#006064", width: 1 },
                EMA: { title: "EMA", isHidden: false, plottype: "line", visible: true, color: "#FF5252", width: 1 },
                BuyPrice: { title: "BuyPrice", isHidden: false, plottype: "line", visible: true, color: "#2962FF", width: 1 },
                BuySL: { title: "BuySL", isHidden: false, plottype: "line", visible: false, color: "#FF9800", width: 1 },
                BuyMarker: {
                    title: "BuyMarker",
                    isHidden: false,
                    plottype: "shape_arrow_up",
                    visible: true,
                    location: "BelowBar",
                    transparency: 0,
                    color: "green",
                    text: "Buy",
                    size: "small",
                    textColor: "gray"
                },
                SellMarker: {
                    title: "SellMarker",
                    isHidden: false,
                    plottype: "shape_arrow_down",
                    visible: true,
                    location: "AboveBar",
                    transparency: 0,
                    color: "red",
                    text: "Sell",
                    size: "small",
                    textColor: "gray"
                },
            },
            inputs: [
                { id: "bbPeriod", group: 'BOLLINGER BANDS SETTINGS', name: "BB Period", type: "integer", defval: 50, min: 1 },
                { id: "bbWidth", group: 'BOLLINGER BANDS SETTINGS', name: "BB Width", type: "float", defval: 2, min: 0.1 },
                { id: "emaPeriod", group: 'EMA SETTINGS', name: "EMA Period", type: "integer", defval: 100, min: 1 },
                { id: "atrPeriod", group: 'ATR SETTINGS', name: "ATR Period", type: "integer", defval: 14, min: 1 },
                { id: "atrFactor", group: 'ATR SETTINGS', name: "ATR Factor", type: "float", defval: 1.8, min: 0.1 },
                { id: "slMode", group: 'STOPLOSS SETTINGS', name: "Stoploss Mode", type: "text", defval: "%", options: ["Off", "%", "Pts"] },
                { id: "slValue", group: 'STOPLOSS SETTINGS', name: "Stoploss Value", type: "float", defval: 20, min: 0.1 },
                { id: "showDashboard", name: "Show Dashboard", type: "bool", defval: true }
            ],
            scriptIdPart: "",
            scriptVersion: "",
            isCustomIndicator: true,
            format: { type: "inherit" }
        },
        constructor: function () {
            const self = this;
            self.closes = [];
            self.highs = [];
            self.lows = [];
            self.opens = [];
            self.volumes = [];
            self.prevEma = undefined;
            self.prevKEma = undefined;
            self.prevATR = undefined;
            self.prevKATR = undefined;
            self.prevATRSL = undefined;
            self.prevKATRSL = undefined;
            self.prevBuyPrice = undefined;
            self.prevBuySL = undefined;
            self.positionSize = 0;
            self.shortPositionSize = 0;
            self.prevShortPrice = undefined;
            self.prevShortSL = undefined;
            self.kbbTopArr = [];
            self.kbbBotArr = [];
            self.kATRSLArr = [];
            self.kemaValArr = [];
            self.barIndex = 0;
            self.lastBarTime = null;
            self.mainSignalHistory = [];
            self.mainSignal = 0;
            self.buySignal = 0;
            self.shortSignal = 0;
            self.closedTrades = [];
            self.lastTradeInfo = { profit: 0, profitPer: 0, entry: 0, size: 0, type: '' };
            // Helper to get the correct BB source
            function getBBSource(ctx, sourceType) {
                switch (sourceType) {
                    case 'open': return PineJS.Std.open(ctx);
                    case 'high': return PineJS.Std.high(ctx);
                    case 'low': return PineJS.Std.low(ctx);
                    case 'close': return PineJS.Std.close(ctx);
                    case 'hl2': return (PineJS.Std.high(ctx) + PineJS.Std.low(ctx)) / 2;
                    case 'hlc3': return (PineJS.Std.high(ctx) + PineJS.Std.low(ctx) + PineJS.Std.close(ctx)) / 3;
                    case 'ohlc4': return (PineJS.Std.open(ctx) + PineJS.Std.high(ctx) + PineJS.Std.low(ctx) + PineJS.Std.close(ctx)) / 4;
                    default: return PineJS.Std.close(ctx);
                }
            }
            function trimArray(arr, maxLen) {
                while (arr.length > maxLen)
                    arr.shift();
            }
            self.main = (ctx, inputCallback) => {
                self._input = inputCallback;
                // Inputs
                let bbSourceType = 'close'; // default
                let bbPeriod = self._input(0);
                let bbWidth = self._input(1);
                let emaPeriod = self._input(2);
                let atrPeriod = self._input(3);
                let atrFactor = self._input(4);
                let slMode = self._input(5);
                let slValue = self._input(6);
                let showDashboard = self._input(7);
                bbPeriod = (typeof bbPeriod === 'undefined') ? 50 : bbPeriod;
                bbWidth = (typeof bbWidth === 'undefined') ? 2 : bbWidth;
                emaPeriod = (typeof emaPeriod === 'undefined') ? 100 : emaPeriod;
                atrPeriod = (typeof atrPeriod === 'undefined') ? 14 : atrPeriod;
                atrFactor = (typeof atrFactor === 'undefined') ? 1.8 : atrFactor;
                slMode = (typeof slMode === 'undefined') ? '%' : slMode;
                slValue = (typeof slValue === 'undefined') ? 20 : slValue;
                showDashboard = (typeof showDashboard === 'undefined') ? true : showDashboard;
                //Dashboard is removed from setting
                if (!showDashboard) {
                    self.removeDashboard();
                }
                // Set minimum additional depth for PineJS calculations
                const maxLen = Math.max(bbPeriod, emaPeriod, atrPeriod) + 10;
                const maxSignalHistory = 500;
                const maxClosedTrades = 100;
                ctx.setMinimumAdditionalDepth(maxLen);
                let usePineJs = PineJS && PineJS.Std && PineJS.Std.sma && PineJS.Std.stdev && PineJS.Std.ema && PineJS.Std.atr;
                if (!usePineJs) {
                    return;
                }
                // Get OHLCV using PineJS series
                let closeSeries, openSeries, highSeries, lowSeries, volumeSeries;
                try {
                    closeSeries = ctx.new_var(PineJS.Std.close(ctx));
                    openSeries = ctx.new_var(PineJS.Std.open(ctx));
                    highSeries = ctx.new_var(PineJS.Std.high(ctx));
                    lowSeries = ctx.new_var(PineJS.Std.low(ctx));
                    volumeSeries = ctx.new_var(PineJS.Std.volume(ctx));
                }
                catch (e) {
                    console.error('[CWA2Sigma] Error accessing OHLCV:', e);
                    return [null, null, null, null, null, null, null, null];
                }
                const close = closeSeries.get(0);
                const prevClose = closeSeries.get(1);
                const open = openSeries.get(0);
                const high = highSeries.get(0);
                const low = lowSeries.get(0);
                const volume = volumeSeries.get(0);
                // Store values for backward compatibility
                self.opens.push(open);
                self.highs.push(high);
                self.lows.push(low);
                self.closes.push(close);
                self.volumes.push(volume);
                // Maintain max length
                trimArray(self.opens, maxLen);
                trimArray(self.highs, maxLen);
                trimArray(self.lows, maxLen);
                trimArray(self.closes, maxLen);
                trimArray(self.volumes, maxLen);
                let bbSource = getBBSource(ctx, bbSourceType);
                let bbSourceSeries = ctx.new_var(bbSource);
                // Bolinger Band Calculation
                let BBMid = PineJS.Std.sma(bbSourceSeries, bbPeriod, ctx);
                let BBStd = PineJS.Std.stdev(bbSourceSeries, bbPeriod, ctx);
                let BBTop = BBMid + bbWidth * BBStd;
                self.kbbTopArr.push(BBTop);
                trimArray(self.kbbTopArr, maxLen);
                // If you use kbbBotArr, also trim it here
                if (self.kbbBotArr)
                    trimArray(self.kbbBotArr, maxLen);
                // EMA Calculation
                let emaVal = PineJS.Std.ema(ctx.new_var(close), emaPeriod, ctx);
                self.kemaValArr.push(emaVal);
                trimArray(self.kemaValArr, maxLen);
                // Calculation for ATR and ATRSL
                let atrSeries = ctx.new_var(PineJS.Std.atr(Number(atrPeriod), ctx));
                let ATR = parseFloat(Number(atrSeries.get(0)).toFixed(2));
                let prevATR = parseFloat(Number(atrSeries.get(1)).toFixed(2));
                // Calculate ATRSL using previous Candle close
                let _ATRSL = prevClose - (prevATR * atrFactor);
                self.kATRSLArr.push(_ATRSL);
                trimArray(self.kATRSLArr, maxLen);
                let ATRSL = (self.kATRSLArr.length > 0) ? self.kATRSLArr[self.kATRSLArr.length - 1] : null;
                // --- Bar index for barstate.isconfirmed emulation ---
                let barTime = ctx.symbol && ctx.symbol.time ? ctx.symbol.time : self.barIndex;
                let isNewBar = (barTime !== self.lastBarTime);
                self.lastBarTime = barTime;
                if (isNewBar)
                    self.barIndex++;
                let isConfirmed = isNewBar; // treat as confirmed only on new bar
                // --- Signal Logic (match PineScript) ---
                let st = 1, et = 0;
                let PosSize = Math.abs(self.positionSize);
                let eBuy = close > BBTop;
                let eSell = close < ATRSL || close < emaVal;
                let prevMainSignal = self.mainSignalHistory.length > 0 ? self.mainSignalHistory[self.mainSignalHistory.length - 1] : 0;
                let MainSignal = prevMainSignal;
                let BuySignal = st && eBuy && isConfirmed && (prevMainSignal <= 0);
                let ShortSignal = 0; // not implemented in PineScript
                let SellSignal = (((ShortSignal || eSell) && isConfirmed) || et) && (prevMainSignal == 1);
                let CoverSignal = 0; // not implemented in PineScript
                if (BuySignal)
                    MainSignal = 1;
                else if (ShortSignal)
                    MainSignal = -1;
                else if ((SellSignal && prevMainSignal > 0) || !PosSize)
                    MainSignal = 0;
                else if ((CoverSignal && prevMainSignal < 0) || !PosSize)
                    MainSignal = 0;
                else
                    MainSignal = prevMainSignal;
                self.mainSignal = MainSignal;
                self.mainSignalHistory.push(MainSignal);
                trimArray(self.mainSignalHistory, maxSignalHistory);
                // --- Buy/SL State Handling ---
                if (BuySignal && self.positionSize === 0) {
                    self.positionSize = 1;
                    self.prevBuyPrice = close;
                    if (slMode === "%") {
                        self.prevBuySL = close * (1 - slValue / 100);
                    }
                    else if (slMode === "Pts") {
                        self.prevBuySL = close - slValue;
                    }
                    else {
                        self.prevBuySL = null;
                    }
                }
                else if ((et || (SellSignal && !ShortSignal) || (close < self.prevBuySL)) && self.positionSize > 0) {
                    self.positionSize = 0;
                    self.prevBuyPrice = null;
                    self.prevBuySL = null;
                }
                // --- Plotting ---
                // Only plot BuyPrice/BuySL when in a long position
                let plotBuyPrice = self.positionSize > 0 ? self.prevBuyPrice : null;
                let plotBuySL = self.positionSize > 0 ? self.prevBuySL : null;
                let kbbTopPlot = (self.kbbTopArr.length > 0) ? self.kbbTopArr[self.kbbTopArr.length - 1] : null;
                let kATRSLPlot = ATRSL;
                let kemaValPlot = (self.kemaValArr.length > 0) ? self.kemaValArr[self.kemaValArr.length - 1] : null;
                // Buy/Sell markers
                let buyMarker = (BuySignal) ? close : null;
                let sellMarker = (SellSignal) ? close : null;
                if (typeof self.closedTrades === 'undefined')
                    self.closedTrades = [];
                if (typeof self.lastTradeInfo === 'undefined')
                    self.lastTradeInfo = { profit: 0, profitPer: 0, entry: 0, size: 0, type: '' };
                if ((self.positionSize === 0 && prevMainSignal > 0) && (self.prevBuyPrice !== null && typeof self.prevBuyPrice !== 'undefined')) {
                    let profit = close - self.prevBuyPrice;
                    let profitPer = (profit / self.prevBuyPrice) * 100;
                    self.closedTrades.push({ profit, profitPer, entry: self.prevBuyPrice, size: 1, type: 'Long' });
                    trimArray(self.closedTrades, maxClosedTrades);
                    self.lastTradeInfo = { profit, profitPer, entry: self.prevBuyPrice, size: 1, type: 'Long' };
                }
                if ((self.shortPositionSize === 0 && prevMainSignal < 0) && (self.prevShortPrice !== null && typeof self.prevShortPrice !== 'undefined')) {
                    let profit = self.prevShortPrice - close;
                    let profitPer = (profit / self.prevShortPrice) * 100;
                    self.closedTrades.push({ profit, profitPer, entry: self.prevShortPrice, size: 1, type: 'Short' });
                    trimArray(self.closedTrades, maxClosedTrades);
                    self.lastTradeInfo = { profit, profitPer, entry: self.prevShortPrice, size: 1, type: 'Short' };
                }
                let slDisplay = 0;
                if (self.positionSize > 0) {
                    const maxSL = Math.max(self.prevBuySL != null ? self.prevBuySL : -Infinity, kATRSLPlot != null ? kATRSLPlot : -Infinity, kemaValPlot != null ? kemaValPlot : -Infinity);
                    slDisplay = isFinite(maxSL) ? maxSL.toFixed(2) : 0;
                }
                else if (self.shortPositionSize < 0 && self.prevShortSL != null) {
                    slDisplay = self.prevShortSL.toFixed(2);
                }
                let openProfit = 0;
                let openProfitPer = 0;
                let buyPrice = self.prevBuyPrice;
                let shortPrice = self.prevShortPrice;
                if (self.positionSize > 0 && buyPrice) {
                    openProfit = close - buyPrice;
                    openProfitPer = (openProfit / buyPrice) * 100;
                }
                else if (self.shortPositionSize < 0 && shortPrice) {
                    openProfit = shortPrice - close;
                    openProfitPer = (openProfit / shortPrice) * 100;
                }
                // let lastTrade = self.lastTradeInfo;
                // let lastTradeStr = lastTrade && lastTrade.entry ? `${lastTrade.type} @ ${lastTrade.entry.toFixed(2)}: ${lastTrade.profit.toFixed(2)} (${lastTrade.profitPer.toFixed(2)}%)` : '-';
                let html = `<div id="cwa2sigma-dashboard" style="
            position:absolute;
            top:30vh;
            left:60px;
            z-index: 900 !important;
            background:rgba(30,40,60,0.92);
            font-family:'Arial',sans-serif;
            min-width:100px;
            max-width:130px;
            pointer-events:none;
        ">
          <table style="width:100%;border-collapse:collapse;box-shadow:0 1px 4px rgba(0,0,0,0.2);">
            <tr>
              <th colspan="2" style="background:#142850;color:#fff;font-size:12px;padding:3px 0;border:1px solid #111;text-align:center;">Dashboard</th>
            </tr>
            <tr>
              <td style="background:#2e7d32;color:#fff;padding:3px 5px;border:1px solid #111;font-size:11px;">Buy</td>
              <td style="background:#2e7d32;color:#fff;padding:3px 5px;text-align:center; border:1px solid #111;font-weight:bold;font-size:11px;">
              ${self.positionSize > 0 ? (buyPrice ? buyPrice.toFixed(2) : 0) : self.shortPositionSize < 0 ? (shortPrice ? shortPrice.toFixed(2) : 0) : 0}
              </td>
            </tr>
            <tr>
              <td style="background:#388e3c;color:#fff;padding:3px 5px;border:1px solid #111;font-size:11px;">Qty.</td>
              <td style="background:#388e3c;color:#fff;padding:3px 5px;text-align:center; border:1px solid #111;font-weight:bold;font-size:11px;">
              ${(self.positionSize > 0 || self.shortPositionSize < 0) ? 1 : 0}
              </td>
            </tr>
            <tr>
              <td style="background:#c62828;color:#fff;padding:3px 5px;border:1px solid #111;font-size:11px;">SL</td>
              <td style="background:#c62828;color:#fff;padding:3px 5px;text-align:center; border:1px solid #111;font-weight:bold;font-size:11px;">
              ${slDisplay}
              </td>
            </tr>
            <tr>
              <td style="background:#1b5e20;color:#fff;padding:3px 5px;border:1px solid #111;font-size:11px;">P&L</td>
              <td style="background:#1b5e20;color:#fff;padding:3px 5px;text-align:center; border:1px solid #111;font-weight:bold;font-size:11px;">
              ${openProfit.toFixed(2)} (${openProfitPer.toFixed(2)}%)
              </td>
            </tr>
          </table>
        </div>`;
                // Always remove existing dashboard first
                if (typeof window !== 'undefined' && document && document.body) {
                    let dashboard = document.getElementById('cwa2sigma-dashboard');
                    if (!showDashboard) {
                        if (dashboard)
                            dashboard.remove();
                    }
                    else {
                        try {
                            if (!dashboard) {
                                let container = document.createElement('div');
                                container.innerHTML = html;
                                if (container.firstChild) {
                                    document.body.appendChild(container.firstChild);
                                    observeTradingViewMenuAndToggleDashboard();
                                }
                            }
                            else {
                                let tableMatch = html.match(/<table[\s\S]*<\/table>/);
                                if (tableMatch) {
                                    dashboard.innerHTML = tableMatch[0];
                                }
                            }
                        }
                        catch (e) {
                            console.error('[CWA2Sigma] Error rendering dashboard:', e);
                        }
                    }
                }
                return [
                    isNaN(kbbTopPlot) ? null : kbbTopPlot,
                    isNaN(kATRSLPlot) ? null : kATRSLPlot,
                    isNaN(kemaValPlot) ? null : kemaValPlot,
                    plotBuyPrice,
                    plotBuySL,
                    buyMarker,
                    sellMarker
                ];
            };
            self.removeDashboard = self.removeDashboard || function () {
                try {
                    let old = document.getElementById('cwa2sigma-dashboard');
                    if (old) {
                        old.remove();
                    }
                }
                catch (e) {
                    console.error('[CWA2Sigma] Error removing dashboard:', e);
                }
            };
            if (typeof window !== 'undefined' && window.tvWidget) {
                // Only add event listeners once
                if (!window._cwa2sigma_listener_added) {
                    window._cwa2sigma_listener_added = true;
                    try {
                        window.tvWidget.subscribe('study_event', (entityId, studyEventType) => {
                            if (studyEventType === 'remove') {
                                let studies = window.tvWidget.activeChart().getAllStudies();
                                let isCwa2Present = !!studies.find(study => study.name === "CWA 2 Sigma Indicator");
                                if (!isCwa2Present) {
                                    setTimeout(() => self.removeDashboard(), 100);
                                }
                            }
                        });
                        if (!window._cwa2sigma_properties_listener_added) {
                            window._cwa2sigma_properties_listener_added = true;
                            window.tvWidget.subscribe('study_properties_changed', (studyId) => {
                                try {
                                    const studies = window.tvWidget.activeChart().getAllStudies();
                                    const myStudy = studies.find(s => s.name === "CWA 2 Sigma Indicator");
                                    if (!myStudy)
                                        return;
                                    if (myStudy.id === studyId) {
                                        const studyApi = window.tvWidget.activeChart().getStudyById(studyId);
                                        if (studyApi && typeof studyApi.isVisible === 'function' && studyApi.isVisible())
                                            return;
                                        self.removeDashboard();
                                    }
                                }
                                catch (e) {
                                    console.error('[CWA2Sigma] Error in study_properties_changed:', e);
                                }
                            });
                        }
                    }
                    catch (e) {
                        console.error('[CWA2Sigma] Error setting up study event listener:', e);
                    }
                }
            }
        }
    };
}
export default CWA2SigmaIndicator;
